<template>
	<div class="dashboard">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Orders</h1>
		<div v-if="this.shops.length > 0" class="shop-selecter-wrapper">
			<div class="radioCheck">
				<b-radio v-model="exportType" name="name" native-value="all">All</b-radio>
				<b-radio v-model="exportType" name="name" native-value="brandOnly">Brand Only</b-radio>
				<b-radio v-model="exportType" name="name" native-value="bdFocOnly">BD FOC Items Only</b-radio>
				<b-radio v-model="exportType" name="name" native-value="brandFocOnly">Brand FOC Items Only</b-radio>
				<b-radio v-model="exportType" name="name" native-value="bsmOnly">BSM Items Only</b-radio>
			</div>

			<div v-if="displayBrandOnlySelection">
				<div class="brandOnlySelection">
					<span class="export-type-span">Export Type</span>
					<b-radio v-model="brandOnlySelection" native-value="summery">Summery</b-radio>
					<b-radio v-model="brandOnlySelection" native-value="details">Details</b-radio>
				</div>
			</div>

			<b-field label="Select Brand (required)" v-if="displayBrandSelection">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="code"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>
			<br />

			<b-field :label="selectShopLabel">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<b-field label="Online Sales Brand (Optional)" v-if="exportType == 'all'">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (onlineSalesBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<br />

			<div class="datepickerWrapper">
				<b-field label="Orders From (required)">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today">
						<button class="button is-primary" @click="startingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="startingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button>
					</b-datepicker>
				</b-field>

				<b-field label="To (required)">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
						:max-date="maxDate"
					>
						<button class="button is-primary" @click="endingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="endingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button>
					</b-datepicker>
				</b-field>
			</div>

			<div class="button-container" @click="getOrders">
				<div class="big-button">Export Orders</div>
			</div>
			<br /><br />
			<div v-if="progress > 0">
				<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"
					>{{ currentOrder }} of {{ this.orders.length }}</b-progress
				>
			</div>

			<!-- <p>{{ currentOrder }} of {{ this.orders.length }}</p> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'Dashboard',
	data: function() {
		return {
			isLoading: false,
			orders: [],
			orderDetails: [],
			onlineSalesBrand: null,
			exportType: 'all',
			brandOnlySelection: 'summery',
			displayBrandOnlySelection: false,
			displayBrandSelection: false,
			shops: [],
			shopsSuggestions: '',
			selectShopLabel: 'Select Shop (required)',
			selectedShop: null,
			ordersTotal: null,
			shopId: null,
			startingDate: null,
			endingDate: null,
			minDate: null,
			maxDate: null,
			brands: [],
			selectedBrand: null,
			brandSuggestions: '',
			focProducts: {},
			currentOrder: 0,
			progress: 0
		}
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		// Upon type selection, display or hide brand selection
		exportType: function(data) {
			if (data == 'brandOnly' || data == 'brandFocOnly') {
				this.displayBrandSelection = true
			} else {
				this.displayBrandSelection = false
			}

			if (data == 'brandOnly') {
				this.displayBrandOnlySelection = true
			} else {
				this.displayBrandOnlySelection = false
			}

			if (data == 'bdFocOnly' || data == 'brandFocOnly') {
				this.selectShopLabel = 'Select Shop (Optional)'
			} else {
				this.selectShopLabel = 'Select Shop (required)'
			}
		},

		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				// Removed as client requested
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		if (this.$route.params.shopId) {
			this.shopId = this.$route.params.shopId
			await this.getOrders()
		} else {
			await this.getShops()
		}

		this.getBrands()
	},

	methods: {
		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			console.log(apiGetBrands)

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list

				this.brands.unshift({ code: 'ALL', name: 'ALL', _id: 'all' })
			}
		},

		getOrders: async function() {
			this.orders = []
			this.orderDetails = []
			this.focProducts = {}
			this.currentOrder = 0
			this.progress = 0

			if (this.startingDate === null || this.endingDate === null) {
				this.$swal.fire('Required Fields!', 'Please make sure Starting Date and Ending Date are selected!', 'error')
				return
			}

			if (this.exportType !== 'bdFocOnly' && this.exportType !== 'brandFocOnly' && this.selectedShop === null) {
				this.$swal.fire('Shop!', 'Please select a shop!', 'error')
				return
			}

			if (this.exportType === 'brandFocOnly' && this.selectedBrand === null) {
				this.$swal.fire('Brand!', 'Please select a brand!', 'error')
				return
			}

			if (this.exportType === 'brandOnly' && this.selectedBrand === null) {
				this.$swal.fire('Brand!', 'Please select a brand!', 'error')
				return
			}

			this.isLoading = true

			var getTotal = await this.apiGetOrders()

			if (getTotal.total == 0) {
				this.isLoading = false
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Nothing found!'
				})

				return
			}

			var totalLoop = Math.ceil(getTotal.total / 5000)

			if (totalLoop > 1) {
				var i = 2

				while (i <= totalLoop) {
					await this.apiGetOrders(i)

					i++
				}
			}

			if (this.exportType == 'all') {
				this.exportAll()
			} else if (this.exportType == 'brandOnly' && this.selectedBrand.code == 'ALL') {
				this.exportAll()
			} else if (this.exportType == 'brandOnly' && this.selectedBrand.code !== 'ALL') {
				this.exportBrandOnly()
			} else if (this.exportType == 'brandFocOnly') {
				this.exportBrandFoc()
			} else if (this.exportType == 'bdFocOnly') {
				this.exportBdFoc()
			} else if (this.exportType === 'bsmOnly') {
				this.exportBsmOnly()
			}
		},

		exportBsmOnly: async function() {
			// var matchProducts = {}
			let products = []

			if (this.orders.length > 0) {
				for (let order of this.orders) {
					this.currentOrder++
					this.progress = (this.currentOrder / this.orders.length) * 100

					var data = {
						id: order._id
					}

					var orderDetail = await this.$api.getOrderDetails({ data })

					if (orderDetail !== undefined) {
						for (let item of orderDetail.data.items) {
							if (item.product.brand == '5e4256885f67a40bf7ad6b7f') {
								// Search brand from state
								const matchedBrand = this.brands.filter(brand => {
									return brand._id == '5e4256885f67a40bf7ad6b7f'
								})

								products.push({
									order_date: this.$moment(order.updatedAt).format('DD/MM/YYYY'),
									order_time: this.$moment(order.updatedAt).format('HH:mm:ss'),
									order_id: order.alias,
									bd_code: item.product.bd_code,
									name: item.product.name,
									brand_name: matchedBrand[0].name,
									brand_code: matchedBrand[0].code,
									barcode: item.product.barcode,
									price: item.product.price,
									qty: item.qty,
									discount: this.calculateDiscount(item) ? this.calculateDiscount(item) : '0'
								})

								// if (!matchProducts[item.product.bd_code]) {
								// 	matchProducts[item.product.bd_code] = {
								// 		order_date: this.$moment(order.updatedAt).format('DD/MM/YYYY'),
								// 		order_time: this.$moment(order.updatedAt).format('HH:mm:ss'),
								// 		order_id: order.alias,
								// 		bd_code: item.product.bd_code,
								// 		name: item.product.name,
								// 		brand_name: matchedBrand[0].name,
								// 		brand_code: matchedBrand[0].code,
								// 		barcode: item.product.barcode,
								// 		price: item.product.price,
								// 		qty: item.qty,
								// 		discount: this.calculateDiscount(item) ? this.calculateDiscount(item) : '0'
								// 	}
								// } else {
								// 	let qty = matchProducts[item.product.bd_code].qty + item.qty

								// 	matchProducts[item.product.bd_code].qty = qty
								// }
							}

							// For buy 1 get 1 items
							const itemPromotions = item.promotions
							if (itemPromotions && itemPromotions.length > 0 && itemPromotions[0].type == 'discount_product_buy_and_get_foc_from_list') {
								if (itemPromotions[0].options && itemPromotions[0].options.products && itemPromotions[0].options.products.length > 0) {
									let matchProducts = {}
									for (let focItem of itemPromotions[0].options.products) {
										const focData = await this.getProductDetail(focItem)

										// Make sure brand is as we selected
										if (focData.brand._id == '5e4256885f67a40bf7ad6b7f') {
											if (focData) {
												// products.push({
												// 	order_date: this.$moment(order.updatedAt).format('DD/MM/YYYY'),
												// 	order_time: this.$moment(order.updatedAt).format('HH:mm:ss'),
												// 	order_id: order.alias,
												// 	bd_code: focData.bd_code,
												// 	name: focData.name,
												// 	brand_name: focData.brand.name,
												// 	brand_code: focData.brand.code,
												// 	barcode: focData.barcode,
												// 	price: 0,
												// 	qty: 1,
												// 	discount: 0
												// })

												if (!matchProducts[focData.bd_code]) {
													matchProducts[focData.bd_code] = {
														order_date: this.$moment(order.updatedAt).format('DD/MM/YYYY'),
														order_time: this.$moment(order.updatedAt).format('HH:mm:ss'),
														order_id: order.alias,
														bd_code: focData.bd_code,
														name: focData.name,
														brand_name: focData.brand.name,
														brand_code: focData.brand.code,
														barcode: focData.barcode,
														price: 0,
														qty: 1,
														discount: 0
													}
												} else {
													let qty = matchProducts[focData.bd_code].qty + 1

													matchProducts[focData.bd_code].qty = qty
												}
											}
										}
									}

									for (let product in matchProducts) {
										if (matchProducts[product].bd_code) {
											products.push(matchProducts[product])
										}
									}
								}
							}
						}

						// For Order FOC and Brand FOC
						if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
							for (let orderPromo of orderDetail.data.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (
										orderPromo.type == 'discount_order_foc__from_product_list' ||
										orderPromo.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand'
									) {
										let matchProducts = {}

										for (let orderFocItem of orderPromo.options.products) {
											const orderFocData = await this.getProductDetail(orderFocItem)

											// Make sure brand is correct
											if (orderFocData.brand._id == '5e4256885f67a40bf7ad6b7f') {
												if (orderFocData) {
													// products.push({
													// 	order_date: this.$moment(order.updatedAt).format('DD/MM/YYYY'),
													// 	order_time: this.$moment(order.updatedAt).format('HH:mm:ss'),
													// 	order_id: order.alias,
													// 	bd_code: orderFocData.bd_code,
													// 	name: orderFocData.name,
													// 	brand_name: orderFocData.brand.name,
													// 	brand_code: orderFocData.brand.code,
													// 	barcode: orderFocData.barcode,
													// 	price: 0,
													// 	qty: 1,
													// 	discount: 0
													// })

													if (!matchProducts[orderFocData.bd_code]) {
														matchProducts[orderFocData.bd_code] = {
															order_date: this.$moment(order.updatedAt).format('DD/MM/YYYY'),
															order_time: this.$moment(order.updatedAt).format('HH:mm:ss'),
															order_id: order.alias,
															bd_code: orderFocData.bd_code,
															name: orderFocData.name,
															brand_name: orderFocData.brand.name,
															brand_code: orderFocData.brand.code,
															barcode: orderFocData.barcode,
															price: 0,
															qty: 1,
															discount: 0
														}
													} else {
														let qty = matchProducts[orderFocData.bd_code].qty + 1

														matchProducts[orderFocData.bd_code].qty = qty
													}
												}
											}
										}

										for (let product in matchProducts) {
											if (matchProducts[product].bd_code) {
												products.push(matchProducts[product])
											}
										}
									}
								}
							}
						}
					}
				}
			}

			let csv = ''
			let lineNumber = 1
			let shop_id = this.selectedShop.shop_id

			products.map(product => {
				const toAdd = [
					shop_id.toUpperCase(), // Shop ID
					product.order_date, // Order Created Date
					product.order_time, // Order Created Time
					product.order_id, // Line number
					lineNumber, // Serial Number
					product.bd_code, // BD Code
					product.name, // Produce Name
					product.qty, // Total Quantity
					(product.price - product.discount) * product.qty, // Price with discount
					product.discount * product.qty, // Discount amount
					null,
					null,
					null,
					null,
					null,
					0 // Tax
				]

				let row = toAdd.join('|')

				csv += row + '\r\n'
				lineNumber++
			})

			// Transform objects into array
			// for (let products in matchProducts) {
			// 	let product = matchProducts[products]

			// 	const toAdd = [
			// 		shop_id.toUpperCase(), // Shop ID
			// 		product.order_date, // Order Created Date
			// 		product.order_time, // Order Created Time
			// 		product.order_id, // Line number
			// 		lineNumber, // Serial Number
			// 		product.bd_code, // BD Code
			// 		product.name, // Produce Name
			// 		product.qty, // Total Quantity
			// 		(product.price - product.discount) * product.qty, // Price with discount
			// 		product.discount * product.qty, // Discount amount
			// 		null,
			// 		null,
			// 		null,
			// 		null,
			// 		null,
			// 		0 // Tax
			// 	]

			// 	let row = toAdd.join('|')

			// 	csv += row + '\r\n'
			// 	lineNumber++
			// }

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'BSM_Order_Export.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		exportBrandOnly: function() {
			if (this.brandOnlySelection == 'summery') {
				this.exportSummery()
			} else {
				this.exportDetails()
			}
		},

		exportSummery: async function() {
			var matchProducts = {}
			let foundMatch = false

			if (this.orders.length > 0) {
				for (let order of this.orders) {
					var data = {
						id: order._id
					}

					this.currentOrder++
					this.progress = (this.currentOrder / this.orders.length) * 100

					var orderDetail = await this.$api.getOrderDetails({ data })

					if (orderDetail !== undefined) {
						for (let item of orderDetail.data.items) {
							if (item.product.brand == this.selectedBrand._id) {
								foundMatch = true
								// Search brand from state
								const matchedBrand = this.brands.filter(brand => {
									return brand._id == item.product.brand
								})

								if (!matchProducts[item.product.bd_code]) {
									matchProducts[item.product.bd_code] = {
										bd_code: item.product.bd_code,
										name: item.product.name,
										brand_name: matchedBrand[0].name,
										brand_code: matchedBrand[0].code,
										barcode: item.product.barcode,
										price: item.product.price,
										qty: item.qty,
										foc: 0,
										net_amount: item.total_price
									}
								} else {
									let qty = matchProducts[item.product.bd_code].qty + item.qty
									let net_amount = matchProducts[item.product.bd_code].net_amount + item.total_price

									matchProducts[item.product.bd_code].qty = qty
									matchProducts[item.product.bd_code].net_amount = net_amount
								}
							}

							// For buy 1 get 1 items
							const itemPromotions = item.promotions
							if (
								itemPromotions &&
								itemPromotions.length > 0 &&
								(itemPromotions[0].type == 'discount_product_buy_and_get_foc_from_list' ||
									itemPromotions[0].type == 'discount_product_buy_one_get_one_and_percentage')
							) {
								if (itemPromotions[0].options && itemPromotions[0].options.products && itemPromotions[0].options.products.length > 0) {
									for (let focItem of itemPromotions[0].options.products) {
										const focData = await this.getProductDetail(focItem)

										// Make sure brand is as we selected
										if (focData.brand._id == this.selectedBrand._id) {
											if (focData) {
												if (!matchProducts[focData.bd_code]) {
													matchProducts[focData.bd_code] = {
														bd_code: focData.bd_code,
														name: focData.name,
														brand_name: focData.brand.name,
														brand_code: focData.brand.code,
														barcode: focData.barcode,
														price: 0,
														qty: 0,
														foc: 1,
														net_amount: 0
													}
												} else {
													let foc = matchProducts[focData.bd_code].foc + 1

													matchProducts[focData.bd_code].foc = foc
												}
											}
										}
									}
								}
							}
						}

						// For Order FOC and Brand FOC
						if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
							for (let orderPromo of orderDetail.data.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (
										orderPromo.type == 'discount_order_foc__from_product_list' ||
										orderPromo.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand' ||
										orderPromo.type == 'discount_order_buy_two_get_one'
									) {
										for (let orderFocItem of orderPromo.options.products) {
											const orderFocData = await this.getProductDetail(orderFocItem)

											// Make sure brand is correct
											if (orderFocData.brand._id == this.selectedBrand._id) {
												if (orderFocData) {
													if (!matchProducts[orderFocData.bd_code]) {
														matchProducts[orderFocData.bd_code] = {
															bd_code: orderFocData.bd_code,
															name: orderFocData.name,
															brand_name: orderFocData.brand.name,
															brand_code: orderFocData.brand.code,
															barcode: orderFocData.barcode,
															price: 0,
															qty: 0,
															foc: 1,
															net_amount: 0
														}
													} else {
														let foc = matchProducts[orderFocData.bd_code].foc + 1

														matchProducts[orderFocData.bd_code].foc = foc
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}

			let csv = 'BD CODE,PRODUCT NAME,BRAND NAME,BRAND CODE,BARCODE,PRICE,QUANTITY,FOC QUANTITY,NET AMOUNT\r\n'

			// Transform objects into array
			for (let products in matchProducts) {
				let product = matchProducts[products]

				const toAdd = [
					product.bd_code,
					'"' + product.name + '"',
					'"' + product.brand_name + '"',
					product.brand_code,
					'"' + product.barcode + '"',
					product.price,
					product.qty,
					product.foc,
					product.net_amount
				]

				let row = toAdd.join(',')

				csv += row + '\r\n'
			}

			if (!foundMatch) {
				this.$swal.fire('Nothing found!', 'Nothing found!', 'info')
				this.isLoading = false
				return
			}

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', this.selectedBrand.code + '_summery.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		exportDetails: async function() {
			let csv = ''
			let foundMatch = false

			let total = 0
			csv +=
				'DATE,TIME,ORDER ID,CASHIER,BD CODE,BRAND NAME,BRAND CODE,PRODUCT NAME,BARCODE,PRICE,DISCOUNT,SPECIAL DISCOUNT,QUANTITY,FOC QUANTITY,NET AMOUNT\r\n'

			if (this.orders.length > 0) {
				for (let order of this.orders) {
					this.currentOrder++
					this.progress = (this.currentOrder / this.orders.length) * 100

					let orderTotal = 0

					var data = {
						id: order._id
					}

					var orderDetail = await this.$api.getOrderDetails({ data })

					if (orderDetail !== undefined) {
						for (let item of orderDetail.data.items) {
							if (item.product.brand == this.selectedBrand._id) {
								foundMatch = true

								// Search brand from state
								const matchedBrand = this.brands.filter(brand => {
									return brand._id == item.product.brand
								})

								const toAdd = [
									this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
									this.$moment(order.updatedAt).format('HH:mm'), // Time
									order.alias, // Order ID
									order.cashier.name, // Cashier Name
									item.product.bd_code, // BD Code
									'"' + matchedBrand[0].name + '"', // Brand Name
									matchedBrand[0].code, // Brand Code
									'"' + item.product.name + '"', // Product Name
									'"' + item.product.barcode + '"', // Barcode
									item.product.price, // Price
									this.calculateDiscount(item) ? this.calculateDiscount(item) : '0', // Discount Amount
									item.special_discount_percent ? item.special_discount_percent : '0', // Special Discount
									item.qty, // Quantity
									'',
									item.total_price // Net Amount
								]

								orderTotal += item.total_price

								let row = toAdd.join(',')

								csv += row + '\r\n'
							}

							// For buy 1 get 1 items
							const itemPromotions = item.promotions

							if (
								itemPromotions &&
								itemPromotions.length > 0 &&
								(itemPromotions[0].type == 'discount_product_buy_and_get_foc_from_list' ||
									itemPromotions[0].type == 'discount_product_buy_one_get_one_and_percentage')
							) {
								if (itemPromotions[0].options && itemPromotions[0].options.products && itemPromotions[0].options.products.length > 0) {
									for (let focItem of itemPromotions[0].options.products) {
										const focData = await this.getProductDetail(focItem)

										// Make sure brand is as we selected
										if (focData.brand._id == this.selectedBrand._id) {
											foundMatch = true
											if (focData) {
												const focToAdd = [
													this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
													this.$moment(order.updatedAt).format('HH:mm'), // Time
													order.alias, // Order ID
													order.cashier.name, // Cashier Name
													focData.bd_code, // BD Code
													'"' + focData.brand.name + '"', // Brand Name
													focData.brand.code, // Brand Code
													'"' + focData.name + '"', // Product Name
													'"' + focData.barcode + '"', // Barcode
													'0', // Price
													'0', // Discount Amount
													'0', // Special Discount
													'',
													'1', // Quantity
													'0'
												] // Net Amount

												let focRow = focToAdd.join(',')

												csv += focRow + '\r\n'
											}
										}
									}
								}
							}
						}

						// For Order FOC and Brand FOC
						if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
							for (let orderPromo of orderDetail.data.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (
										orderPromo.type == 'discount_order_foc__from_product_list' ||
										orderPromo.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand' ||
										orderPromo.type == 'discount_order_buy_two_get_one'
									) {
										for (let orderFocItem of orderPromo.options.products) {
											const orderFocData = await this.getProductDetail(orderFocItem)

											// Make sure brand is correct
											if (orderFocData.brand._id == this.selectedBrand._id) {
												foundMatch = true
												if (orderFocData) {
													const focToAdd = [
														this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
														this.$moment(order.updatedAt).format('HH:mm'), // Time
														order.alias, // Order ID
														order.cashier.name, // Cashier Name
														orderFocData.bd_code, // BD Code
														'"' + orderFocData.brand.name + '"', // Brand Name
														orderFocData.brand.code, // Brand Code
														'"' + orderFocData.name + '"', // Product Name
														'"' + orderFocData.barcode + '"', // Barcode
														'0', // Price
														'0', // Discount Amount
														'0', // Special Discount
														'',
														'1', // Quantity
														'0'
													] // Net Amount

													let orderFocRow = focToAdd.join(',')

													csv += orderFocRow + '\r\n'
												}
											}
										}
									}
								}
							}
						}

						if (foundMatch == true) {
							if (order.coupons && order.coupons.length > 0) {
								// csv +=
								// 	',' +
								// 	this.$moment(order.updatedAt).format('DD/MM/YYYY') +
								// 	',' +
								// 	this.$moment(order.updatedAt).format('HH:mm') +
								// 	',' +
								// 	order.alias +
								// 	',' +
								// 	order.cashier.name +
								// 	',,,,,,,,' +
								// 	'\r\n'

								for (let coupon of order.coupons) {
									const matchedBrand = this.brands.filter(brand => {
										return brand._id == coupon.brand
									})

									csv +=
										this.$moment(order.updatedAt).format('DD/MM/YYYY') +
										',' +
										this.$moment(order.updatedAt).format('HH:mm') +
										',' +
										order.alias +
										',' +
										order.cashier.name +
										',' +
										matchedBrand[0].code +
										',' +
										matchedBrand[0].name +
										',' +
										matchedBrand[0].code +
										',' +
										'COUPONS' +
										',' +
										matchedBrand[0].code +
										',,,,,,' +
										coupon.amount +
										'\r\n'
								}

								csv += '\r\n'
							}

							if (orderDetail.data.description) {
								csv += ',,,,,,,,,,,,,REMARKS,"' + orderDetail.data.description + '"\r\n'
							}

							// To filter out zero payment checkouts
							// if (orderDetail.data.items && orderDetail.data.items.length > 0) {
							if (orderTotal > 0) {
								csv += ',,,,,,,,,,,,,Total,' + orderTotal + '\r\n'
								csv += '\r\n'
							}

							total += orderTotal
						}
					}
				}

				if (foundMatch == true) {
					csv += '=,=,=,=,=,=,=,=,=,=,=,=,=,=,=' + '\r\n'
					csv += ',,,,,,,,,,,,,OVERALL TOTAL,' + total.toFixed(2) + '\r\n'
					csv += '=,=,=,=,=,=,=,=,=,=,=,=,=,=,=' + '\r\n'
				}
			}

			if (!foundMatch) {
				this.$swal.fire('Nothing found!', 'Nothing found!', 'info')
				this.isLoading = false
				return
			}

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'orders.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		exportBdFoc: async function() {
			let csv = ''
			let foundMatch = false

			let focProduct = []

			if (this.orders.length > 0) {
				for (let order of this.orders) {
					// var data = {
					// 	id: order._id
					// }

					this.currentOrder++
					this.progress = (this.currentOrder / this.orders.length) * 100

					// var orderDetail = await this.$api.getOrderDetails({ data })

					let orderDetail = order

					if (orderDetail) {
						// For Order FOC and Brand FOC
						if (orderDetail.promotions && orderDetail.promotions.length > 0) {
							for (let orderPromo of orderDetail.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (orderPromo.type == 'discount_order_foc__from_product_list') {
										for (let orderFocItem of orderPromo.options.products) {
											let orderFocData = null

											// Find if this product is already in object
											if (focProduct.length > 0) {
												orderFocData = focProduct.find(o => o._id === orderFocItem)
											}

											if (!orderFocData) {
												orderFocData = await this.getProductDetail(orderFocItem)

												focProduct.push(orderFocData)
											}

											if (orderFocData) {
												foundMatch = true

												if (this.focProducts[orderFocData.bd_code]) {
													this.focProducts[orderFocData.bd_code].qty++
												} else {
													const data = {
														product: orderFocData,
														qty: 1
													}

													this.focProducts[orderFocData.bd_code] = data
												}
											}
										}
									}
								}
							}
						}
					}
				}

				csv = 'BD CODE,PRODUCT NAME,BARCODE,QUANTITY\r\n'
				for (const focItem in this.focProducts) {
					const focToAdd = [
						this.focProducts[focItem].product.bd_code, // BD Code
						'"' + this.focProducts[focItem].product.name + '"', // Product Name
						'"' + this.focProducts[focItem].product.barcode + '"', // Barcode
						this.focProducts[focItem].qty // Quantity
					] // Net Amount

					let orderFocRow = focToAdd.join(',')

					csv += orderFocRow + '\r\n'
				}
			}

			if (!foundMatch) {
				this.$swal.fire('Nothing found!', 'Nothing found!', 'info')
				this.isLoading = false
				return
			}

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'orders.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		exportBrandFoc: async function() {
			let csv = ''
			let foundMatch = false

			if (this.orders.length > 0) {
				for (let order of this.orders) {
					var data = {
						id: order._id
					}

					this.currentOrder++
					this.progress = (this.currentOrder / this.orders.length) * 100

					var orderDetail = await this.$api.getOrderDetails({ data })

					if (orderDetail !== undefined) {
						for (let item of orderDetail.data.items) {
							// For buy 1 get 1 items
							const itemPromotions = item.promotions
							if (
								itemPromotions &&
								itemPromotions.length > 0 &&
								(itemPromotions[0].type == 'discount_product_buy_and_get_foc_from_list' ||
									itemPromotions[0].type == 'discount_product_buy_one_get_one_and_percentage')
							) {
								if (itemPromotions[0].options && itemPromotions[0].options.products && itemPromotions[0].options.products.length > 0) {
									for (let focItem of itemPromotions[0].options.products) {
										const focData = await this.getProductDetail(focItem)

										if (this.selectedBrand.code == 'ALL' || this.selectedBrand._id == focData.brand._id) {
											foundMatch = true

											if (this.focProducts[focData.bd_code]) {
												this.focProducts[focData.bd_code].qty++
											} else {
												const data = {
													product: focData,
													qty: 1
												}

												this.focProducts[focData.bd_code] = data
											}
										}
									}
								}
							}
						}

						// For Order FOC and Brand FOC
						if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
							for (let orderPromo of orderDetail.data.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (
										orderPromo.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand' ||
										orderPromo.type == 'discount_order_buy_two_get_one'
									) {
										for (let orderFocItem of orderPromo.options.products) {
											const orderFocData = await this.getProductDetail(orderFocItem)

											if (orderFocData) {
												if (this.selectedBrand.code == 'ALL' || this.selectedBrand._id == orderFocData.brand._id) {
													foundMatch = true

													if (this.focProducts[orderFocData.bd_code]) {
														this.focProducts[orderFocData.bd_code].qty++
													} else {
														const data = {
															product: orderFocData,
															qty: 1
														}

														this.focProducts[orderFocData.bd_code] = data
													}
												}
											}
										}
									}
								}
							}
						}

						csv = 'BD CODE,BRAND NAME,BRAND CODE,PRODUCT NAME,BARCODE,QUANTITY\r\n'
						for (const focItem in this.focProducts) {
							const focToAdd = [
								this.focProducts[focItem].product.bd_code, // BD Code
								'"' + this.focProducts[focItem].product.brand.name + '"', // BD Name
								this.focProducts[focItem].product.brand.code, // BD Code
								'"' + this.focProducts[focItem].product.name + '"', // Product Name
								'"' + this.focProducts[focItem].product.barcode + '"', // Barcode
								this.focProducts[focItem].qty // Quantity
							] // Net Amount

							let orderFocRow = focToAdd.join(',')

							csv += orderFocRow + '\r\n'
						}
					}
				}
			}

			if (!foundMatch) {
				this.$swal.fire('Nothing found!', 'Nothing found!', 'info')
				this.isLoading = false
				return
			}

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'orders.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		exportAll: async function() {
			let csv = ''
			let total = 0
			csv +=
				'DATE,TIME,ORDER ID,CASHIER,BD CODE,BRAND NAME,BRAND CODE,PRODUCT NAME,BARCODE,PRICE,DISCOUNT,SPECIAL DISCOUNT,QUANTITY,FOC QUANTITY,NET AMOUNT,REMARKS,ONLINE SALES\r\n'

			if (this.orders.length > 0) {
				for (let order of this.orders) {
					var data = {
						id: order._id
					}

					this.currentOrder++
					this.progress = (this.currentOrder / this.orders.length) * 100

					var orderDetail = await this.$api.getOrderDetails({ data })

					if (orderDetail !== undefined) {
						for (let item of orderDetail.data.items) {
							// Search brand from state
							const matchedBrand = this.brands.filter(brand => {
								return brand._id == item.product.brand
							})

							console.log(matchedBrand)

							let onlineSalesBrand

							if (orderDetail.data.online_sales) {
								// Search brand from state
								onlineSalesBrand = this.brands.find(brand => {
									return brand._id == orderDetail.data.online_sales
								})

								this.onlineSalesBrand = onlineSalesBrand
							} else {
								this.onlineSalesBrand = null
							}

							// To set remarks
							var orderRemark = orderDetail.data.description ? orderDetail.data.description : ''

							const toAdd = [
								this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
								this.$moment(order.updatedAt).format('HH:mm'), // Time
								order.alias, // Order ID
								order.cashier.name, // Cashier Name
								item.product.bd_code, // BD Code
								'"' + matchedBrand[0].name + '"', // Brand Name
								matchedBrand[0].code, // Brand Code
								'"' + item.product.name + '"', // Product Name
								'"' + item.product.barcode + '"', // Barcode
								item.product.price, // Price
								this.calculateDiscount(item) ? this.calculateDiscount(item) : '0', // Discount Amount
								item.special_discount_percent ? item.special_discount_percent : '0', // Special Discount
								item.qty, // Quantity
								'',
								item.total_price, // Net Amount
								'"' + orderRemark + '"',
								onlineSalesBrand ? onlineSalesBrand.name : ''
							]

							let row = toAdd.join(',')

							csv += row + '\r\n'

							// For buy 1 get 1 items
							const itemPromotions = item.promotions

							if (
								itemPromotions &&
								itemPromotions.length > 0 &&
								(itemPromotions[0].type == 'discount_product_buy_and_get_foc_from_list' ||
									itemPromotions[0].type == 'discount_product_buy_one_get_one_and_percentage')
							) {
								if (itemPromotions[0].options && itemPromotions[0].options.products && itemPromotions[0].options.products.length > 0) {
									for (let focItem of itemPromotions[0].options.products) {
										const focData = await this.getProductDetail(focItem)

										// if (this.exportType == "all") {
										if (focData) {
											const focToAdd = [
												this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
												this.$moment(order.updatedAt).format('HH:mm'), // Time
												order.alias, // Order ID
												order.cashier.name, // Cashier Name
												focData.bd_code, // BD Code
												'"' + focData.brand.name + '"', // Brand Name
												focData.brand.code, // Brand Code
												'"' + focData.name + '"', // Product Name
												'"' + focData.barcode + '"', // Barcode
												'0', // Price
												'0', // Discount Amount
												'0', // Special Discount
												'',
												'1', // Quantity
												'0',
												'"' + orderRemark + '"',
												onlineSalesBrand ? onlineSalesBrand.name : ''
											] // Net Amount

											let focRow = focToAdd.join(',')

											csv += focRow + '\r\n'
										}
									}
								}
							}
						}

						// For Order FOC and Brand FOC
						if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
							for (let orderPromo of orderDetail.data.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (
										orderPromo.type == 'discount_order_foc__from_product_list' ||
										orderPromo.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand' ||
										orderPromo.type == 'discount_order_buy_two_get_one'
									) {
										for (let orderFocItem of orderPromo.options.products) {
											const orderFocData = await this.getProductDetail(orderFocItem)

											let onlineSalesBrand

											if (orderDetail.data.online_sales) {
												// Search brand from state
												onlineSalesBrand = this.brands.find(brand => {
													return brand._id == orderDetail.data.online_sales
												})
												this.onlineSalesBrand = onlineSalesBrand
											} else {
												this.onlineSalesBrand = null
											}

											if (orderFocData) {
												const focToAdd = [
													this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
													this.$moment(order.updatedAt).format('HH:mm'), // Time
													order.alias, // Order ID
													order.cashier.name, // Cashier Name
													orderFocData.bd_code, // BD Code
													'"' + orderFocData.brand.name + '"', // Brand Name
													orderFocData.brand.code, // Brand Code
													'"' + orderFocData.name + '"', // Product Name
													'"' + orderFocData.barcode + '"', // Barcode
													'0', // Price
													'0', // Discount Amount
													'0', // Special Discount
													'',
													'1', // Quantity
													'0',
													'"' + orderRemark + '"',
													onlineSalesBrand ? onlineSalesBrand.name : ''
												] // Net Amount

												let orderFocRow = focToAdd.join(',')

												csv += orderFocRow + '\r\n'
											}
										}
									}
								}
							}
						}

						if (this.exportType == 'all' || this.exportType == 'brandOnly') {
							if (order.coupons && order.coupons.length > 0) {
								// csv += ',,,,,,,,,,,,COUPONS' + '\r\n'

								for (let coupon of order.coupons) {
									const matchedBrand = this.brands.filter(brand => {
										return brand._id == coupon.brand
									})

									const couponOnlineSales = this.onlineSalesBrand ? this.onlineSalesBrand.name : ''

									csv +=
										this.$moment(order.updatedAt).format('DD/MM/YYYY') +
										',' +
										this.$moment(order.updatedAt).format('HH:mm') +
										',' +
										order.alias +
										',' +
										order.cashier.name +
										',' +
										matchedBrand[0].code +
										',' +
										matchedBrand[0].name +
										',' +
										matchedBrand[0].code +
										',' +
										'COUPONS' +
										',' +
										matchedBrand[0].code +
										',,,,,,' +
										coupon.amount +
										',,' +
										couponOnlineSales +
										'\r\n'
								}

								csv += '\r\n'
							}

							// To filter out zero payment checkouts
							if (orderDetail.data.items && orderDetail.data.items.length > 0) {
								csv += ',,,,,,,,,,,,,Total,' + order.total_price + '\r\n'
								csv += '\r\n'
							}

							total += order.total_price
						}
					}
				}

				if (this.exportType == 'brandOnly') {
					csv += 'Exported Brand Only with All' + '\r\n'
				}

				csv += '=,=,=,=,=,=,=,=,=,=,=,=,=,=,=' + '\r\n'
				csv += ',,,,,,,,,,,,,OVERALL TOTAL,' + total.toFixed(2) + '\r\n'
				csv += '=,=,=,=,=,=,=,=,=,=,=,=,=,=,=' + '\r\n'
			}

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'orders.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		getProductDetail: async function(product_id) {
			const data = {
				id: product_id,
				populate: ['brand']
			}

			const getFocProduct = await this.$api.getProductDetail({
				data
			})

			if (getFocProduct !== undefined) {
				return getFocProduct.data
			} else {
				return
			}
		},

		calculateDiscount: function(item) {
			if (item.promotions && item.promotions.length > 0) {
				// For 2 percentage discounts
				if (
					item.promotions[0].type == 'discount_product_percentage_by_brands' ||
					item.promotions[0].type == 'discount_product_percentage' ||
					item.promotions[0].type == 'discount_product_buy_one_get_one_and_percentage'
				) {
					console.log(item)
					return (item.product.price * item.promotions[0].condition.percentage) / 100
				} else if (item.promotions[0].type == 'discount_product_price') {
					// For fixed price discount (price point)
					return item.promotions[0].condition.price
				}
			} else if (item.special_discount_percent !== 0) {
				// For special discount
				return (item.product.price * item.special_discount_percent) / 100
			}
		},

		apiGetOrders: async function(skip = 0) {
			var data = {}
			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			if (skip) {
				skip = (skip - 1) * 5000
			}

			data = {
				populate: ['cashier'],
				skip,
				pay_status: 1,
				limit: 5000,
				time: {
					createdAt
				},
				sort: {
					createdAt: 'asc'
				}
			}

			if (this.selectedShop && this.selectedShop._id !== null) {
				data.shop = this.selectedShop._id
			}

			// For BD FOC Only
			if (this.exportType === 'bdFocOnly') {
				data.promotionsType = 'discount_order_foc__from_product_list'
			}

			// For online sales
			if (this.exportType === 'all' && this.onlineSalesBrand && this.onlineSalesBrand._id) {
				data.online_sales = this.onlineSalesBrand._id
			}

			const apiGetOrders = await this.$api.getOrders({ data })

			if (apiGetOrders !== undefined && apiGetOrders.data.count > 0) {
				for (let order of apiGetOrders.data.list) {
					this.orders.push(order)
				}

				return apiGetOrders.data
			} else {
				this.$swal.fire('Sorry. Nothing found!')
				this.isLoading = false
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
